import React, { createContext, useState } from 'react'
import styled from 'styled-components'
import { SubPageBreadCrumbs } from 'Components/BreadCrumbs'
import { Level2Menu } from 'Components/Menus'
import { auctionMenu } from '../constants'
import { DataTable } from './components'

export const LocationGroupsContext = createContext()

const Container = styled.div``

function LocationGroupsPage() {
    const [selectedRecord, setSelectedRecord] = useState({})

    return (
        <LocationGroupsContext.Provider value={{ selectedRecord, setSelectedRecord }}>
            <Container>
                <SubPageBreadCrumbs />
                <Level2Menu menu={auctionMenu} />
                <DataTable />
            </Container>
        </LocationGroupsContext.Provider>
    )
}

export default LocationGroupsPage
